import DARK from './dark'
import LIGHT from './light'

export const setSpectrum = (mode = 'light') => (mode === 'dark' ? DARK : LIGHT)

export const v1 = {
  AMARANTH: '#F0414A',
  AMARANTH_OVERLAY: 'rgb(240, 65, 74, 0.25)',
  AQUAMARINE: '#64C5AF',
  SCOOTER: '#2C949A',
  SCOOTER_OVERLAY: 'rgba(44, 154, 151, 0.5)',
  ATOLL: '#296C78',
  AQUA_GRADIENT: 'linear-gradient(90deg, #64C5AF, #25AC9E)',
  AQUA_OVERLAY_ACTIVE: 'rgba(104, 196, 175, 0.5)',
  AQUA_OVERLAY: 'rgba(104, 196, 175, 0.25)',
  LIGHT_TEAL: '#d2f2eb',
  REGAL: '#24446C',
  MIDNIGHT: '#191654',
  PALE_BLUE: '#F1F5F9',
  BLUE_GRADIENT: 'linear-gradient(90deg, #191654, #24446C)',
  BLUE_GRADIENT_HORIZONTAL:
    'linear-gradient(to bottom right, #191654, #24446C)',
  BLACK: '#000000',
  BLACK_SHADOW: 'rgba(0, 0, 0, 0.5)',
  CHARCOAL: '#333333',
  MORTAR: '#555555',
  GREY: '#888888',
  SILVER: '#AAAAAA',
  STONE: '#CCCCCC',
  GALLERY: '#EEEEEE',
  SMOKE: '#F5F5F5',
  WHITE: '#FFFFFF',
  WATERMELON: '#FB646B',
  SAFFRON: '#F7B05B',
  ORANGE: '#FFA500',
  SUNSET: '#F5D7AD',
  SOLITUDE: '#EBEFF3',
  LIGHT_CHARCOAL: '#474747',
  ALICE_BLUE: '#EBF1F7',
  VIVID: '#31609B',
  ...setSpectrum('light'),
}

export const v2 = (mode = 'light') => {
  return {
    // TODO deprecate once everything is on v2 design tokens
    // leftover v1 tokens so things don't break out of the gate
    AMARANTH: '#F0414A',
    AMARANTH_OVERLAY: 'rgb(240, 65, 74, 0.25)',
    AQUAMARINE: '#64C5AF',
    SCOOTER: '#2C949A',
    SCOOTER_OVERLAY: 'rgba(44, 154, 151, 0.5)',
    ATOLL: '#296C78',
    AQUA_GRADIENT: 'linear-gradient(90deg, #64C5AF, #25AC9E)',
    AQUA_OVERLAY_ACTIVE: 'rgba(104, 196, 175, 0.5)',
    AQUA_OVERLAY: 'rgba(104, 196, 175, 0.25)',
    LIGHT_TEAL: '#d2f2eb',
    REGAL: '#24446C',
    MIDNIGHT: '#191654',
    PALE_BLUE: '#F1F5F9',
    BLUE_GRADIENT: 'linear-gradient(90deg, #191654, #24446C)',
    BLUE_GRADIENT_HORIZONTAL:
      'linear-gradient(to bottom right, #191654, #24446C)',
    BLACK: '#000000',
    BLACK_SHADOW: 'rgba(0, 0, 0, 0.5)',
    CHARCOAL: '#333333',
    MORTAR: '#555555',
    GREY: '#888888',
    SILVER: '#AAAAAA',
    STONE: '#CCCCCC',
    GALLERY: '#EEEEEE',
    SMOKE: '#F5F5F5',
    WHITE: '#FFFFFF',
    WATERMELON: '#FB646B',
    SAFFRON: '#F7B05B',
    ORANGE: '#FFA500',
    SUNSET: '#F5D7AD',
    SOLITUDE: '#EBEFF3',
    LIGHT_CHARCOAL: '#474747',
    ALICE_BLUE: '#EBF1F7',

    /**
     * anything below this line is really part of the design system 2.0
     */

    // special colors
    bronze: '#8C7853',
    gold: '#E5B73B',
    platinum: '#C0CADB',

    ...setSpectrum(mode),
  }
}
